import { Input as UIInput } from '@flippingbook/web.react-kit/dist/Input';
import cx from 'classnames';
import { forwardRef } from 'react';

import { b } from './style.css';

type UIInputProps = React.ComponentPropsWithoutRef<typeof UIInput>;

export const Input = forwardRef<HTMLInputElement, UIInputProps>(function Input(props, ref) {
    return (
        <UIInput
            {...props}
            ref={ref}
            className={cx(props.className, b.name)}
        />
    );
});
